//
// Copyright 2024 DXOS.org
//

export const styles = {
  default: 'text-neutral-500',
  success: 'text-sky-300 dark:text-green-700',
  warning: 'text-orange-300 dark:text-orange-600',
  error: 'text-red-300 dark:text-red-600',
};
